import React from "react";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faUserPlus,
  faSchool,
} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";

const NewSchool = () => {
  return (
    <section className="position-relative overflow-hidden pt-5 pt-lg-3">
      <div style={{textAlign: "center"}}>
        <h1 className="text-center">학교 단체 학습자</h1>
        <p className="text-truncate-2 mb-2">학교/단체 신규 가입 안내</p>

        <div className="tab-content" id="course-pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="course-pills-tabs-1"
            role="tabpanel"
            aria-labelledby="course-pills-tab-1"
          >
            <div className="row g-4">
              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="card shadow h-100">
                  <Link to="/schoolAdminRegistration" className="mb-3">
                    <Button
                      variant="success"
                      size="lg"
                      className="card-img-top"
                    >
                      <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                      학교 관리자 회원가입
                    </Button>
                  </Link>
                  
                  <Link to="/schoolLogin" className="mb-3">
                    <Button
                      variant="outline-success"
                      size="lg"
                      className="card-img-top"
                    >
                      학교 관리자 로그인
                    </Button>
                  </Link>    

                    <div className="card-body pb-0">
                      <h5 className="card-title fw-normal">
                        학교/단체 등록
                      </h5>
                      <p className="mb-2 text-truncate-2">
                        학교/단체 라이선스 구매 후 계정 생성하고 학습을
                        시작합니다.
                      </p>
                      <ul className="text-dark" style={{textAlign: "left"}}>
                        <li>견적서 : 학교 정보 등록</li>
                        <li>결제 : 라이선스 구매</li>
                        <li>계정 : 교사/학생 계정 생성</li>
                        <li>학습 : 초코파이썬 시작</li>
                        <li>동영상 매뉴얼 학습</li>
                      </ul>
                    </div>            
                </div>
              </div>

              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="card shadow h-100">
                  <Link to="/schoolReg" className="mb-3">
                    <Button variant="success" size="lg" className="card-img-top">
                      학교 정보 등록
                    </Button>

                    <div className="card-body pb-0">
                      <p className="mb-2 text-truncate-2">
                        계약관련 정보등록과 견적서 출력
                      </p>
                      <ul className="text-dark" style={{textAlign: "left"}}>
                        <li>정보등록</li>
                        <li>견적서 저장/출력</li>
                        <li>구매 상담</li>
                        <li>고객센터 : 032-582-0100</li>
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>

              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div id="license" className="card shadow h-100">
                  <Link to="/SchoolPayment" className="mb-3">                  
                    <Button
                      variant="success"
                      size="lg"
                      className="card-img-top"
                    >
                      라이선스 구매
                    </Button>

                    <div className="card-body pb-0">
                      <p className="mb-2 text-truncate-2">
                        계약서 작성, 결제, 전자세금계산서
                      </p>
                      <ul className="text-dark" style={{textAlign: "left"}}>
                        <li>계약서 작성</li>
                        <li>결제 : 라이선스 구매</li>
                        <li>전자세금계산서 발행</li>
                        <li>고객센터 : 032-582-0100</li>
                      </ul>
                      
                      <div>
                        <img
                          src="assets/images/pay/payment_icon_yellow_small.png"
                          alt="카카오페이"
                          className="w-5 h-5"
                        />                   
                      </div>
                    </div>
                  </Link>

                  <Link to="/schoolDesk" className="mb-3">
                    <Button
                      variant="outline-success"
                      size="lg"
                      className="card-img-top"
                    >
                      결재 내역 조회
                    </Button>
                  </Link>
                </div>
              </div>

              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="card shadow h-100">
                  <Link to="/newSchool" className="mb-3">
                    <Button variant="success" size="lg" className="card-img-top">
                      <FontAwesomeIcon icon={faSchool} className="me-2" />
                      교사 데스크
                    </Button>
                    <div className="card-body pb-0">
                      <div className="d-flex justify-content-between mb-2">
                        <span className="badge bg-primary bg-opacity-10 text-primary">
                          초/중/고/대학
                        </span>
                        <button className="text-danger border-0 bg-transparent p-0">
                          <i className="fas fa-heart"></i>
                        </button>
                      </div>

                      <h5 className="card-title fw-normal">교사/학생 계정 생성</h5>
                      <div className="card-body pb-0">
                        <p className="mb-2 text-truncate-2">
                          교사 일괄 생성 및 학생 개별 생성 모두 지원
                        </p>
                        <ul className="text-dark" style={{ textAlign: "left" }}>
                          <li>1 ~ 30계정 : 직접생성가능</li>
                          <li>30 계정 이상 : 고객센터지원</li>
                          <li>신청접수 후 바로 생성</li>
                          <li>고객센터 : 032-582-0100</li>
                        </ul>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewSchool;
